import {
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useEffect } from "react";
import { useMutation } from "react-query";
import { viewVitals } from "../../services";
import { useParams } from "react-router-dom";

function VitalsTable() {
  const {encounterId} = useParams()
  const {mutate,isLoading,data} = useMutation(viewVitals)
  useEffect(()=>{
    mutate(encounterId as string)
  },[])
  return (
    <TableContainer>
      {isLoading ? <div className="p-4 flex flex-row gap-3">
          <Typography>Fetching vitals</Typography> <CircularProgress size={20}/>
      </div>:<Table size="small" aria-label="simple table">
      <TableBody>
  <TableRow>
    <TableCell sx={{ border: 0 }} width={200}>HEIGHT (cm)</TableCell>
    <TableCell sx={{ border: 0 }}>: {data?.response?.height || ""}</TableCell>
    <TableCell sx={{ border: 0 }} width={200}>TEMPERATURE (C)</TableCell>
    <TableCell sx={{ border: 0 }}>: {data?.response?.temp || ""}</TableCell>
  </TableRow>
  <TableRow>
    <TableCell sx={{ border: 0 }} width={200}>WEIGHT (kg)</TableCell>
    <TableCell sx={{ border: 0 }}>: {data?.response?.weight || ""}</TableCell>
    <TableCell sx={{ border: 0 }} width={200}>SYSTOLIC BP (mm Hg)</TableCell>
    <TableCell sx={{ border: 0 }}>: {data?.response?.systolicBP || ""}</TableCell>
  </TableRow>
  <TableRow>
    <TableCell sx={{ border: 0 }} width={200}>BMI (kg/m²)</TableCell>
    <TableCell sx={{ border: 0 }}>: {data?.response?.bmi || ""}</TableCell>
    <TableCell sx={{ border: 0 }} width={200}>DIASTOLIC BP (mm Hg)</TableCell>
    <TableCell sx={{ border: 0 }}>: {data?.response?.diastolicBP || ""}</TableCell>
  </TableRow>
  <TableRow>
    <TableCell sx={{ border: 0 }} width={200}>BSA</TableCell>
    <TableCell sx={{ border: 0 }}>: {data?.response?.bsa || ""}</TableCell>
    <TableCell sx={{ border: 0 }}>SUGAR (mg)</TableCell>
    <TableCell sx={{ border: 0 }}>: {data?.response?.sugar || ""}</TableCell>
  </TableRow>
  <TableRow>
    <TableCell sx={{ border: 0 }} width={200}>BLOOD GROUP</TableCell>
    <TableCell sx={{ border: 0 }}>: {data?.response?.bloodgroup || ""}</TableCell>
    <TableCell sx={{ border: 0 }}>PULSE / HEART RATE (bpm)</TableCell>
    <TableCell sx={{ border: 0 }}>: {data?.response?.heartRate || ""}</TableCell>
  </TableRow>
  <TableRow>
    <TableCell sx={{ border: 0 }} width={200}>SPO2 (%)</TableCell>
    <TableCell sx={{ border: 0 }}>: {data?.response?.spo2 || ""}</TableCell>
    <TableCell sx={{ border: 0 }}>RESPIRATORY (Breath/M)</TableCell>
    <TableCell sx={{ border: 0 }}>: {data?.response?.respiratory || ""}</TableCell>
  </TableRow>
  <TableRow>
    <TableCell sx={{ border: 0 }} width={200}>HEAD CIRCUMFERENCE (cm)</TableCell>
    <TableCell sx={{ border: 0 }}>: {data?.response?.headCircumference || ""}</TableCell>
    <TableCell sx={{ border: 0 }}>PAIN SCALE</TableCell>
    <TableCell sx={{ border: 0 }}>: {data?.response?.painscale || ""}</TableCell>
  </TableRow>
  <TableRow>
    <TableCell sx={{ border: 0 }} width={200}>IMMUNISATION HISTORY</TableCell>
    <TableCell sx={{ border: 0 }} colSpan={3}>: {data?.response?.immunisationHistory || ""}</TableCell>
  </TableRow>
</TableBody>

      </Table>}
    </TableContainer>
  );
}

export default VitalsTable;
